import './identifier-and-context.scss'

import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import { IdentifierFieldsArea } from "./identifiers-fields-area";
import { ContextFieldsArea } from "./context-fields-area";

@Component({
    components: {
        sIdentifiersFieldsArea: IdentifierFieldsArea,
        sContextFieldsArea: ContextFieldsArea,
    },
    props: ['reportFeatured', 'conditionReport', 'form', 'fieldName', 'getFieldStatus', 'signers', 'readOnly'],
    template: require('./identifier-and-context.html')
})
export default class IdentifierAndContext extends ReactiveVue {

}